<template>
  <div :class="[_isMobile() ? 'mobile' : '']">
    <div v-if="_isMobile()">
      <h3>请使用电脑浏览器打开此报告，获取更佳体验</h3>
    </div>
    <div v-if="!_isMobile() && reportInfo" class="report" ref="html2canvas">
      <div class="header">
        <div class="logo">
          <img :src="logo ? logo : '/img/logo.png'" alt="" />
        </div>
        <h2 class="title">人工智能核心素养测评报告</h2>
      </div>
      <a-divider></a-divider>
      <a-row class="info">
        <a-col :xl="14" :lg="14" :md="14" :sm="24" :xs="24">
          <a-row type="flex" justify="space-around">
            <a-col flex="200px">
              <img :src="reportInfo.baseInfo.photo" alt="" class="photo" />
            </a-col>
            <a-col flex="auto">
              <ul class="base-info-list">
                <li>
                  <span class="info-title"
                    >姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：{{
                      reportInfo.baseInfo.name
                    }}</span
                  >
                </li>
                <li>
                  <span class="info-title"
                    >档案编号：{{ reportInfo.baseInfo.idcard }}</span
                  >
                </li>
                <li>
                  <span class="info-title"
                    >测评期数：{{ reportInfo.baseInfo.times }}</span
                  >
                </li>
                <li>
                  <span class="info-title"
                    >参测项目：{{ reportInfo.baseInfo.categoryParent }}</span
                  >
                </li>
                <li>
                  <span class="info-title"
                    >评定级别：{{ reportInfo.baseInfo.category }}</span
                  >
                </li>
                <li>
                  <span class="info-title"
                    >评定结果：{{ reportInfo.baseInfo.scoreResult || '再接再厉' }}</span
                  >
                </li>
              </ul>
            </a-col>
          </a-row>
        </a-col>
        <a-col :xl="10" :lg="10" :md="10" :sm="24" :xs="24">
          <img style="height: 300px" src="../assets/report/level.png" alt="" />
        </a-col>
      </a-row>
      <a-card v-for="(value, key, index) in reportInfo.tag" :key="index" class="report-card" :bordered="false" style="min-height: 350px">
        <a-row type="flex" justify="space-around">
          <h2 v-if="_isMobile()" class="tag-title">{{key}}</h2>
          <a-col :flex="_isMobile()? '300px' : '500px'">
            <div
              class="chart"
              :id="'chart-tag-'+index"
              :style="_isMobile()? 'width: 300px; height: 300px':'width: 500px; height: 400px'"
            ></div>
            
          </a-col>
          <a-col v-if="!_isMobile()" flex="5px">
            <div class="divider"></div>
          </a-col>
          <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
            <h2 v-if="!_isMobile()" class="tag-title">{{key}}</h2>
            <a-row class="tag-item" type="flex" align="middle" :gutter="[16,16]" v-for="(item, i) in value" :key="i">
                <a-col :xl="5" :lg="5" :md="5" :sm="24" :xs="24">
                    <h3 class="tag-name">{{item.tagName}}</h3>
                </a-col>
                <a-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
                    <a-progress :strokeWidth="20" :showInfo="false" :stroke-color="rank_color" :percent="item.gotScore/item.score * 100"/>
                </a-col>
                <a-col :xl="11" :lg="11" :md="11" :sm="24" :xs="24" v-if="getTagDesc(item)">
                    <div class="dash-border">
                        {{getTagDesc(item)}}
                    </div>
                </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-card>
      <!-- <div class="footer">
        <h2 class="tips">本报告评价维度及标准基于《中国自动化学会青少年人工智能核心素养测评等级标准与测评大纲》中的各模块及对应级别考评要求。</h2>
        <br><br>
        <a-row type="flex" align="middle" :gutter="[16,16]">
            <a-col :xl="14" :lg="14" :md="14" :sm="24" :xs="24">
               <div class="copy">
                 <h2>主&nbsp;&nbsp;办&nbsp;&nbsp;单&nbsp;&nbsp;位：中国自动化学会</h2>
                <h2>承&nbsp;&nbsp;办&nbsp;&nbsp;单&nbsp;&nbsp;位：CAA智慧教育专业委员会 CAA普及工作委会</h2>
                <h2>学术指导单位：中国科学院大学人工智能学员 西安交通大学计算机科学与技术学院</h2>
               </div>
            </a-col>
            <a-col flex="200px">
                <img
                    class="logo"
                    src="/cert/qrcode.jpg"
                />
            </a-col>
            <a-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24">
                <div class="concat">
                    <h2>电话：4006-982-989</h2>
                    <h2>官网：aice.caa.org.cn</h2>
                </div>
            </a-col>
        </a-row>
      </div> -->
    </div>
    <a-button v-if="reportInfo" style="margin:10px auto;display:block;" icon="download" size="large" type="primary" @click="downloadReport">下载报告</a-button>
    <!-- <img :src="img" alt=""> -->
  </div>
</template>

<script>
import {mixinDevice} from '@/utils/mixin.js'
import { getAction } from "@/api/manage";
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
import * as echarts from "echarts";
export default {
  mixins: [mixinDevice],
  components: {
  },
  data() {
    return {
      // img: "",
      eventApplyId: "",
      logo: "",
      reportInfo: null,
      rank_color: {
        '0%': 'rgb(234,243,255)',
        '100%': 'rgb(101,165,255)',
      },
      //平均情况雷达图style
      areaStyle1: {
        color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
          {
            color: "rgba(247,182,82, 0.1)",
            offset: 0,
          },
          {
            color: "rgba(247,182,82, 0.9)",
            offset: 1,
          },
        ]),
      },
      //学生情况
      areaStyle2: {
        color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
          {
            color: "rgba(129,193,106, 0.1)",
            offset: 0,
          },
          {
            color: "rgba(129,193,106, 0.9)",
            offset: 1,
          },
        ]),
      },
    };
  },
  created() {
    let tenantInfo = this.$store.getters.tenantInfo;
    this.logo = tenantInfo.logo2;
    this.eventApplyId = this.$route.query.eventApplyId;
    if (!this.eventApplyId) {
      this.$message.error("参数错误");
      return;
    }
    if(this._isMobile()){
      // alert("请使用电脑浏览器打开此报告，获取更佳体验")
      return;
    }
    this.getReport(this.eventApplyId);
  },
  mounted() {
  },
  methods: {
    getReport(eventApplyId) {
      getAction("/report/studentCategoryReport", {
        eventApplyId: eventApplyId,
      }).then((res) => {
        if (res.success) {
          if(typeof res.result == 'string'){
            this.reportInfo = JSON.parse(res.result);
          }else{
            this.reportInfo = res.result;
          }
          
          this.$nextTick(() => {
            if (this.reportInfo.tag) {
              this.renderChartTags(this.reportInfo.tag)
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    downloadReport(){
      // 移除 box-shadow 效果
      var elements = document.querySelectorAll('.report-card,.ant-progress-bg,.ant-progress-inner');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.boxShadow = 'none';
      }
      let that = this
      html2canvas(this.$refs.html2canvas, {
        backgroundColor: null,
        useCORS: true // 解决文件跨域问题
      }).then(canvas => {
        const url = canvas.toDataURL('image/png') // 生成的图片
        saveAs(url, that.reportInfo.baseInfo.name+"的评价报告.png")
      })   
    },
    renderChartTags(dataSet){
      let index = 0
       for(let key in dataSet){
        let data = dataSet[key]
        console.log(data);
        let mychart = echarts.init(document.getElementById("chart-tag-"+index));
        mychart.showLoading();
        let option = {
          color:['rgb(247,182,82)','rgb(129,193,106)'],
          legend: {
            data: ["平均情况", "学生情况"],
            left: '0%'
          },
          radar: {
            indicator: [],
            radius: this._isMobile()?'40%':'75%'
          },
          series: [
            {
              name: key,
              type: "radar",
              data: [
                {
                  value: [],
                  name: "平均情况",
                  areaStyle: this.areaStyle1
                },
                {
                  value: [],
                  name: "学生情况",
                  areaStyle: this.areaStyle2
                },
              ],
            },
          ],
        };
        for (let i = 0; i < data.length; i++) {
          let t = data[i];
          option.radar.indicator.push({ name: t.tagName, max: 1 });
          option.series[0].data[0].value.push(t.tagAvgGotScore / t.tagAvgTotalScore);
          option.series[0].data[1].value.push(t.gotScore / t.score);
        }
        setTimeout(function () {
          mychart.setOption(option);
          mychart.hideLoading();
        }, 100);
        index++
       }
    },
    getTagDesc(tag){
      console.log(tag);
      if(tag.tagDesc){
        let tagDescJson
        try{
          tagDescJson = JSON.parse(tag.tagDesc)
        }catch(e){
          return tag.tagDesc
        }
        for(let i=tagDescJson.length-1;i>=0;i--){
          if((tag.gotScore/tag.score*100) >= parseInt(tagDescJson[i].key)){
            return tagDescJson[i].value
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.mobile{
  .report{
    padding: 5px;
  }
  .header{
    .logo {
      position: unset;
    }
  }
  .report-card {
    margin: 10px 5px;
    .tag-name{
      text-align: left;
    }
  }
}
.report {
  background: #f6f7fb;
  max-width: 1366px;
  margin: 0 auto;
  padding: 20px;
  font-family: "微软雅黑";
}

.header {
  min-height: 55px;
  .logo {
    position: absolute;
    margin-top: 5px;
    img {
      display: inline-block;
      height: 50px;
    }
    h2 {
      display: inline;
      font-style: italic;
      font-size: 20px;
      color: #ffffff;
      line-height: 30px;
      text-shadow: #b3b0b0ab 5px 3px 5px;
    }
  }
  .title {
    text-align: center;
    font-weight: 700;
    line-height: 55px;
  }
}

.info {
  margin: 20px;
  .info-title{
    font-weight: 700;
  }
  .photo {
    width: 180px;
    border: 3px solid rgb(210, 221, 241);
  }
  .base-info-list {
    padding: 0;
    li {
      list-style-type: none;
      background: url(../assets/report/li.png) no-repeat 0px center;
      background-size: 10px 10px;
      padding-left: 25px;
      margin: 10px 0;
      span {
        color: black;
        font-size: 16px;
      }
    }
  }
}

.report-card {
  margin: 30px 20px;
  border-radius: 20px;
  box-shadow: #d9d9d9 0px 0px 6px 0px;
  .tag-title{
    font-weight: 700;
    text-align: center;
  }
  .tag-item{
    min-height: 70px;
  }
  .tag-name{
    text-align: right;
    white-space: nowrap;
  }
}

.chart {
  margin: auto;
}
.divider{
    height: 100%;
    width: 5px;
    background-image: linear-gradient(white, rgb(237 237 237), white);
}
.dash-border{
    border-radius:5px;
    border:1px dashed skyblue;
    padding:2px;
}
/deep/.ant-progress{
  .ant-progress-bg, .ant-progress-inner{
      box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
  }
}
.footer{
    .tips{
        text-align:center;
        color:gray;
    }
    .copy{
        h2{
            color: rgb(0,108,187)
        }
    }
    .logo{
        width: 200px; height: 200px; display: block; margin: 0 auto
    }
    .concat{
        h2{
            color: rgb(76,76,76);
            font-weight: 700;
        }
    }
}
</style>